import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import middlewares from './middlewares'

import { persistedState, saveState } from './persisted.store.js';

// Singleton: every caller (React's <Provider>, the API layer, ...) must share
// the exact same store instance, never a separate copy with its own snapshot.
let storeInstance = null;

export default function configureStore() {
    if (storeInstance) return storeInstance;

    storeInstance = createStore(
        reducers,
        persistedState, // second argument overrides the initial state
        applyMiddleware(
            ...middlewares
        )
    );

    // add a listener that will be invoked on any state change
    storeInstance.subscribe(() => {
        saveState(storeInstance.getState());
    });

    return storeInstance;
}